import {
  ScanLine, Crosshair, Scan, ScanFace, Smile, Activity, Cpu, Zap, Waypoints, CircleDot, HelpCircle, Check,
} from "lucide-react";
import { useI18n } from "../i18n/LanguageProvider";
import {
  TECHNOLOGY, TECH_HEADING, TECH_SUB,
  IMPLANT_SYSTEMS, IMPLANT_SELECTION_NOTE, IMPLANT_QUESTIONS,
} from "../data/technology";
import { SectionHeading } from "./Sections";
import { Reveal, RevealStagger, RevealItem } from "./motion/Reveal";

const ICONS = { ScanLine, Crosshair, Scan, ScanFace, Smile, Activity, Cpu, Zap, Waypoints, CircleDot };

export default function Technology({ showImplantSystems = true }) {
  const { t, lang } = useI18n();
  return (
    <section className="container-dv py-16 lg:py-20" data-testid="technology-section">
      <Reveal>
        <SectionHeading eyebrow={t.whyVietnam?.eyebrow || ""} title={TECH_HEADING[lang] || TECH_HEADING.en} sub={TECH_SUB[lang] || TECH_SUB.en} />
      </Reveal>

      <RevealStagger className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {TECHNOLOGY.map((item, i) => {
          const Icon = ICONS[item.icon] || CircleDot;
          return (
            <RevealItem key={i}>
              <div className="h-full rounded-3xl border border-navy/8 bg-white p-6 shadow-soft" data-testid={`tech-card-${i}`}>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-dental/8 text-dental">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="mt-4 text-lg text-navy">{item.title[lang] || item.title.en}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy/65">{item.body[lang] || item.body.en}</p>
              </div>
            </RevealItem>
          );
        })}
      </RevealStagger>

      {showImplantSystems && (
        <Reveal>
          <div className="mt-14 rounded-3xl border border-navy/8 bg-mist p-7 sm:p-9">
            <h3 className="text-xl sm:text-2xl text-navy">
              {lang === "fr" ? "Systèmes d’implants disponibles chez des prestataires sélectionnés"
                : lang === "de" ? "Bei ausgewählten Anbietern verfügbare Implantatsysteme"
                : "Implant systems available through selected providers"}
            </h3>
            <div className="mt-5 flex flex-wrap gap-2.5">
              {IMPLANT_SYSTEMS.map((s) => (
                <span key={s} className="rounded-full border border-navy/12 bg-white px-4 py-2 text-sm font-semibold text-navy">{s}</span>
              ))}
            </div>
            <p className="mt-5 text-[15px] leading-relaxed text-navy/70">{IMPLANT_SELECTION_NOTE[lang] || IMPLANT_SELECTION_NOTE.en}</p>

            <h4 className="mt-8 flex items-center gap-2 text-lg text-navy">
              <HelpCircle className="h-5 w-5 text-turquoise" />
              {lang === "fr" ? "Questions à poser sur votre implant" : lang === "de" ? "Fragen zu Ihrem Implantat" : "Questions to ask about your implant"}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {(IMPLANT_QUESTIONS[lang] || IMPLANT_QUESTIONS.en).map((q, i) => (
                <li key={i} className="flex gap-3 text-[15px] leading-relaxed text-navy/75">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-turquoise" />
                  <span>{q}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      )}
    </section>
  );
}
